module.exports = __webpack_public_path__ + "static/media/logo.af708ce6.svg";